import { ElementType } from 'react';
import cn from 'classnames';

import { useSliderState } from './context';

type SliderItemProps = {
  Component: ElementType;
  withOverflowHidden?: boolean;
};

export default function SliderItem({
  Component,
  withOverflowHidden = true,
}: SliderItemProps) {
  const { items } = useSliderState();

  return (
    <div
      className={cn(
        `rounded-lg bg-whisper shadow-lg md:flex`,
        withOverflowHidden && `overflow-hidden`,
      )}
    >
      <Component items={items} />
    </div>
  );
}
